var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2603_79110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2603_79110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18C8.08333 18 6.41319 17.3646 4.98958 16.0938C3.56597 14.8229 2.75 13.2361 2.54167 11.3333H4.25C4.44444 12.7778 5.08681 13.9722 6.17708 14.9167C7.26736 15.8611 8.54167 16.3333 10 16.3333C11.625 16.3333 13.0035 15.7674 14.1354 14.6354C15.2674 13.5035 15.8333 12.125 15.8333 10.5C15.8333 8.875 15.2674 7.49653 14.1354 6.36458C13.0035 5.23264 11.625 4.66667 10 4.66667C9.04167 4.66667 8.14583 4.88889 7.3125 5.33333C6.47917 5.77778 5.77778 6.38889 5.20833 7.16667H7.5V8.83333H2.5V3.83333H4.16667V5.79167C4.875 4.90278 5.73958 4.21528 6.76042 3.72917C7.78125 3.24306 8.86111 3 10 3C11.0417 3 12.0174 3.19792 12.9271 3.59375C13.8368 3.98958 14.6285 4.52431 15.3021 5.19792C15.9757 5.87153 16.5104 6.66319 16.9062 7.57292C17.3021 8.48264 17.5 9.45833 17.5 10.5C17.5 11.5417 17.3021 12.5174 16.9062 13.4271C16.5104 14.3368 15.9757 15.1285 15.3021 15.8021C14.6285 16.4757 13.8368 17.0104 12.9271 17.4062C12.0174 17.8021 11.0417 18 10 18ZM12.3333 14L9.16667 10.8333V6.33333H10.8333V10.1667L13.5 12.8333L12.3333 14Z",
    fill: "#838383"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.54e8082e6412a593c83f4b25139baf35.svg";
export { ForwardRef as ReactComponent };